import { z } from 'zod';

import zodLocales from 'common/zod/locales';

import locales from './locales';

export const confirmDetailsFormSchema = z
  .object({
    // z.coerce.string().email().optional() does not make the email optional, this seems to be a bug
    // this union is an alternative that works the same as the above
    recipientEmail: z.union([
      z.coerce.string().email(zodLocales.errors.invalidEmail),
      z.coerce.string().max(0).optional(),
    ]),
    shouldNotifyRecipient: z.coerce.boolean(),
  })
  .superRefine(({ recipientEmail, shouldNotifyRecipient }, ctx) => {
    if (shouldNotifyRecipient && !recipientEmail) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: locales.emailIsRequiredError,
        path: ['recipientEmail' as const],
      });
    }
  });

export type ConfirmDetailsFormSchema = z.infer<typeof confirmDetailsFormSchema>;
